// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__oG7i+","tabsHeader":"tabs_tabsHeader__dAosZ","tabContent":"tabs_tabContent__F3UYK"};